import React, { useState, useMemo, useEffect, useRef } from 'react';
import { RiFileList3Line } from "react-icons/ri";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { IoImages } from "react-icons/io5";
import { BsFiletypeDocx } from "react-icons/bs";
import { IoIosFolderOpen } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import RenameFolderModal from './Files/RenameFolderModal';
import MoveFilesComponent from './ViewMyFiles/MoveFilesComponent';
import { copyEnvelopeToMyFiles } from '../../../../services/CommonService';
import { checkMyFilesEnabled } from '../../../../services/CommonService';
import Utils from '../../../../utils';
import PasteToMyFilesModal from './ViewEnvFiles/PasteToMyFilesModal';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../../context/AppContext';
import imageIcon from '../../../../assets/svg/image.svg';
import docxIcon from '../../../../assets/svg/docx.svg';
import pdfIcon from '../../../../assets/svg/pdf.svg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';

const EnvFilesFolderView = ({
  handleOpenDocumentModal,
  sleeveSmartFoldersData,
  onRefreshDocuments,
  userId
}) => {
  const { clipboardData, copyToClipboard, clearClipboard } = useAppContext();
  const navigate = useNavigate();
  const [filterType, setFilterType] = useState('all');
  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [currentPath, setCurrentPath] = useState([]);
  const [currentDisplayItems, setCurrentDisplayItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [moveFiles, setMoveFiles] = useState([]);
  const [isSiteFilesModalOpen, setIsSiteFilesModalOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchText, setSearchText] = useState('');
  const containerRef = useRef(null);
  // const dropdownRef = useRef(null);
  const inputRef = useRef(null); // Added ref for search input
  let longPressTimer = null;
  const [longPressActiveId, setLongPressActiveId] = useState(null);
  const [longPressType, setLongPressType] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  // const [selectedItem, setSelectedItem] = useState(null);
  const [openDropdowns, setOpenDropdowns] = useState({});

  // userData ko define karo
  const userData = Utils.loginUserData();
  const [myFilesEnabled, setMyFilesEnabled] = useState(null); // <-- add state

  useEffect(() => {
    checkMyFilesEnabled({})
      .then(res => {
        if (res.data && typeof res.data.data?.myfiles_enabled !== 'undefined') {
          setMyFilesEnabled(res.data.data.myfiles_enabled);
        } else {
          setMyFilesEnabled(false);
        }
      })
      .catch(err => {
        setMyFilesEnabled(false);
      });
  }, []);

  const getEnvelopeId = (data, folderName) => {
    if (!data || !folderName) return null;
    let currentData = data;
    let currentFolderName = currentPath.length > 0 ? currentPath[0] : folderName;
    const folderContent = currentData[currentFolderName];
    if (!folderContent) return null;
    if (Array.isArray(folderContent)) {
      return folderContent[0]?.envelope_id || null;
    }
    const firstSubFolderName = Object.keys(folderContent)[0];
    if (!firstSubFolderName) return null;
    const files = folderContent[firstSubFolderName];
    if (!Array.isArray(files) || files.length === 0) return null;
    return files[0]?.envelope_id || null;
  };

  useEffect(() => {
    let content = sleeveSmartFoldersData || {};
    if (currentPath.length === 0) {
      if (sleeveSmartFoldersData && typeof sleeveSmartFoldersData === 'object' && !Array.isArray(sleeveSmartFoldersData)) {
        const newDisplayItems = Object.keys(sleeveSmartFoldersData).map(folderName => ({
          name: folderName,
          type: 'folder',
          content: sleeveSmartFoldersData[folderName],
          uuid: sleeveSmartFoldersData[folderName]?.uuid,
          envelope_id: getEnvelopeId(sleeveSmartFoldersData, folderName),
          count: (sleeveSmartFoldersData[folderName] && typeof sleeveSmartFoldersData[folderName] === 'object')
            ? (Array.isArray(sleeveSmartFoldersData[folderName])
              ? sleeveSmartFoldersData[folderName].length
              : Object.keys(sleeveSmartFoldersData[folderName] || {}).length)
            : 0
        }));
        setCurrentDisplayItems(newDisplayItems);
      } else {
        setCurrentDisplayItems([]);
      }
    } else {
      for (const folderName of currentPath) {
        content = (content && typeof content === 'object' && content[folderName]) ? content[folderName] : {};
      }
      if (Array.isArray(content)) {
        const newDisplayItems = content.map(file => ({ ...file, type: 'file', name: file.file_name }));
        setCurrentDisplayItems(newDisplayItems);
      } else if (typeof content === 'object' && content !== null) {
        const newDisplayItems = Object.keys(content).map(subFolderName => ({
          name: subFolderName,
          type: 'folder',
          content: content[subFolderName],
          uuid: content[subFolderName]?.uuid,
          envelope_id: getEnvelopeId(sleeveSmartFoldersData, subFolderName),
          count: (content[subFolderName] && typeof content[subFolderName] === 'object')
            ? (Array.isArray(content[subFolderName])
              ? content[subFolderName].length
              : Object.keys(content[subFolderName] || {}).length)
            : 0
        }));
        setCurrentDisplayItems(newDisplayItems);
      } else {
        setCurrentDisplayItems([]);
      }
    }
  }, [sleeveSmartFoldersData, currentPath]);

  const handleRenameSuccess = (newName) => {
    setCurrentDisplayItems(prev => prev.map(item =>
      item.type === 'folder' && selectedFolder && item.name === selectedFolder.name
        ? { ...item, name: newName }
        : item
    ));
    setSelectedFolder(prev => prev ? { ...prev, name: newName } : prev);
  };

  const getFileIconAndClass = (fileName) => {
    const lowerCaseFileName = fileName?.toLowerCase() || '';
    if (lowerCaseFileName.endsWith('.pdf')) {
      return { icon: pdfIcon, class: 'file-card-pdf pdf-border', type: 'PDF' };
    } else if (['.jpg', '.jpeg', '.png', '.webp'].some(ext => lowerCaseFileName.endsWith(ext))) {
      return { icon: imageIcon, class: 'file-card-image image-border', type: 'IMAGE' };
    } else if (lowerCaseFileName.endsWith('.docx')) {
      return { icon: docxIcon, class: 'file-card-doc doc-border', type: 'DOC' };
    }
    return { icon: pdfIcon, class: 'file-card-doc default-border', type: 'FILE' };
  };

  const getFileType = (fileName) => {
    const lowerCaseFileName = fileName?.toLowerCase() || '';
    if (lowerCaseFileName.endsWith('.pdf')) return 'PDF';
    if (['.jpg', '.jpeg', '.png', '.webp'].some(ext => lowerCaseFileName.endsWith(ext))) return 'IMAGE';
    if (lowerCaseFileName.endsWith('.docx')) return 'DOCX';
    return 'FILE';
  };

  const highlightSearchText = (text, search) => {
    if (!search) return text;
    const parts = text.split(new RegExp(`(${search})`, 'gi'));
    return (
      <span>
        {parts.map((part, index) =>
          part.toLowerCase() === search.toLowerCase() ? (
            <mark key={index} className="bg-warning">{part}</mark>
          ) : (
            part
          )
        )}
      </span>
    );
  };

  const filteredAndSortedItems = useMemo(() => {
    let items = [...currentDisplayItems];

    if (searchText.trim()) {
      items = items.filter(item => {
        const name = item.type === 'folder' ? item.name : item.file_name;
        return name?.toLowerCase().includes(searchText.toLowerCase());
      });
    }

    if (filterType !== 'all') {
      items = items.filter(item => {
        if (filterType === 'folder' && item.type === 'folder') return true;
        if (item.type === 'file') {
          const fileType = getFileType(item.file_name);
          if (filterType === 'pdf' && fileType === 'PDF') return true;
          if (filterType === 'image' && fileType === 'IMAGE') return true;
          if (filterType === 'docx' && fileType === 'DOCX') return true;
          if (filterType === 'other' && !['PDF', 'IMAGE', 'DOCX'].includes(fileType)) return true;
        }
        return false;
      });
    }

    // Helper function to get the latest date from a folder's contents
    const getFolderLatestDate = (content) => {
      let latestDate = 0;
      const traverse = (node) => {
        if (Array.isArray(node)) {
          node.forEach(file => {
            const fileDate = getFileDate(file);
            if (fileDate > latestDate) latestDate = fileDate;
          });
        } else if (typeof node === 'object' && node !== null) {
          Object.values(node).forEach(subNode => traverse(subNode));
        }
      };
      traverse(content);
      return latestDate;
    };

    const getFileDate = (item) => {
      const dateStr = item.updated_at || item.created_at || item.upload_date;
      const date = dateStr ? new Date(dateStr) : null;
      return date && !isNaN(date.getTime()) ? date.getTime() : 0;
    };

    items.sort((a, b) => {
      if (a.type === 'folder' && b.type !== 'folder') return -1;
      if (a.type !== 'folder' && b.type === 'folder') return 1;

      if (sortColumn === 'date') {
        const dateA = a.type === 'folder' ? getFolderLatestDate(a.content) : getFileDate(a);
        const dateB = b.type === 'folder' ? getFolderLatestDate(b.content) : getFileDate(b);
        // If dates are equal, sort by name as secondary criterion
        if (dateA === dateB) {
          const nameA = a.type === 'folder' ? a.name : a.file_name;
          const nameB = b.type === 'folder' ? b.name : b.file_name;
          return (nameA || '').localeCompare(nameB || '');
        }
        return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
      }

      let comparison = 0;
      const nameA = a.type === 'folder' ? a.name : a.file_name;
      const nameB = b.type === 'folder' ? b.name : b.file_name;
      if (sortColumn === 'name') {
        comparison = (nameA || '').localeCompare(nameB || '');
      } else if (sortColumn === 'type') {
        const typeA = a.type === 'folder' ? 'FOLDER' : getFileType(a.file_name);
        const typeB = b.type === 'folder' ? 'FOLDER' : getFileType(b.file_name);
        comparison = (typeA || '').localeCompare(typeB || '');
      }
      return sortDirection === 'asc' ? comparison : -comparison;
    });

    return items;
  }, [currentDisplayItems, filterType, sortColumn, sortDirection, searchText]);
  const counts = useMemo(() => {
    const files = currentDisplayItems.filter(item => item.type === 'file');
    const folders = currentDisplayItems.filter(item => item.type === 'folder');
    return {
      totalFiles: files.length,
      totalFolders: folders.length,
      totalPdfs: files.filter(f => f.file_name?.toLowerCase().endsWith('.pdf')).length,
      totalImages: files.filter(f => ['.jpg', '.jpeg', '.png', '.webp', '.gif'].some(ext => f.file_name?.toLowerCase().endsWith(ext))).length,
      totalDocx: files.filter(f => ['.doc', '.docx'].some(ext => f.file_name?.toLowerCase().endsWith(ext))).length,
    };
  }, [currentDisplayItems]);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const handleFolderClick = (item) => {
    setLoading(true);
    setTimeout(() => {
      setCurrentPath(prevPath => [...prevPath, item.name]);
      setLoading(false);
      setSelectedItems([]);
    }, 1200);
  };

  const handleManageClick = (e, item) => {
    e.stopPropagation();
    if (item.uuid) {
      navigate('/manage/' + item.uuid);
    }
  };

  const handleBreadcrumbClick = (index) => {
    setCurrentPath(currentPath.slice(0, index + 1));
  };

  const handleBackClick = () => {
    if (currentPath.length > 0) {
      setCurrentPath(prevPath => prevPath.slice(0, prevPath.length - 1));
      setSelectedItems([]);
    }
  };

  const handleRenameClick = (e, item) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    const envelopeId = getEnvelopeId(sleeveSmartFoldersData, item.name);
    setSelectedFolder({ ...item, envelope_id: envelopeId });
    setShowRenameModal(true);
  };

  const handleMoveSuccess = ({ targetFolder, movedFileId, movedFile }) => {
    setCurrentDisplayItems(prev => prev.filter(item => item.id !== movedFileId));
    if (currentPath.length > 0 && currentPath[currentPath.length - 1] === targetFolder) {
      setCurrentDisplayItems(prev => [...prev, movedFile]);
    }
    setMoveFiles([]);
  };

  const handleFileMoveClick = (file) => {
    const fileObj = { ...file, file_name: file.file_name || file.name || 'Unknown File' };
    setMoveFiles([fileObj]);
    setShowMoveModal(true);
  };

  const handleSendFolderToMyFiles = (item, isRootFolder) => {
    const clipboardPayload = isRootFolder
      ? { envelope_id: [item.envelope_id] }
      : {
        envelope_id: [getEnvelopeId(sleeveSmartFoldersData, currentPath[0])],
        folder_names: [item.name]
      };
    copyToClipboard(clipboardPayload);
    setIsSiteFilesModalOpen(true);
  };

  const handleSendFileToMyFiles = (item) => {
    const rootFolderName = currentPath[0];
    const clipboardPayload = {
      envelope_id: [currentPath.length > 0 ? getEnvelopeId(sleeveSmartFoldersData, rootFolderName) : item.envelope_id],
      file_ids: [String(item.id)]
    };
    copyToClipboard(clipboardPayload);
    setIsSiteFilesModalOpen(true);
  };

  const handleDropdownVisibleChange = (visible, itemKey) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [itemKey]: visible
    }));
  };

  const closeDropdown = (itemKey) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [itemKey]: false
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-menu') && !event.target.closest('.three-dots')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    const closeDropdown = () => setActiveDropdown(null);
    window.addEventListener('scroll', closeDropdown, true);
    window.addEventListener('resize', closeDropdown, true);
    return () => {
      window.removeEventListener('scroll', closeDropdown, true);
      window.removeEventListener('resize', closeDropdown, true);
    };
  }, []);

  const getBreadcrumbs = () => {
    const crumbs = [
      <span
        key="root"
        onClick={() => setCurrentPath([])}
        className={`breadcrumb-item ${currentPath.length === 0 ? 'active-crumb' : ''}`}
        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
      >
        Home
      </span>
    ];
    currentPath.forEach((folderName, index) => {
      const isLast = index === currentPath.length - 1;
      crumbs.push(<span key={`separator-${index}`} className="mx-1 text-muted">/</span>);
      crumbs.push(
        <span
          key={folderName}
          onClick={() => handleBreadcrumbClick(index)}
          className={`breadcrumb-item ${isLast ? 'active-crumb' : ''}`}
          style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
        >
          {highlightSearchText(folderName, searchText)}
        </span>
      );
    });
    return <div className="d-flex align-items-center flex-wrap">{crumbs}</div>;
  };

  const envelopeId = getEnvelopeId(sleeveSmartFoldersData, currentPath[0] || '');
  const mainFolderName = currentPath[0] || '';

  const handlePasteClipboardItems = async () => {
    if (!clipboardData) {
      toast.info('Clipboard is empty. Select and copy items first.', { autoClose: 2000 });
      return;
    }
    const targetFolderId = currentPath.length > 0 && currentDisplayItems.length > 0
      ? currentDisplayItems.find(i => i.type === 'folder' && i.name === currentPath[currentPath.length - 1])?.id || null
      : null;
    try {
      const payload = {
        ...clipboardData,
        user_id: userId,
        target_folder_id: targetFolderId
      };
      await copyEnvelopeToMyFiles(payload);
      toast.success('Paste successful!');
      clearClipboard();
      if (onRefreshDocuments) onRefreshDocuments();
    } catch (err) {
      toast.error('Failed to paste item.');
      console.error('Paste error:', err);
    }
  };

  const getItemKey = (item) => `${item.type}-${item.id || item.name}`;

  const prepareClipboardData = (items) => {
    if (!items.length) return null;
    const isRootFolder = currentPath.length === 0;
    const rootFolderName = currentPath[0];
    const folders = items.filter(item => item.type === 'folder');
    const files = items.filter(item => item.type === 'file');
    if (folders.length > 0 && files.length > 0) {
      toast.info('Cannot copy mixed selection of folders and files.', { autoClose: 3000 });
      return null;
    }
    if (folders.length > 0) {
      if (isRootFolder && folders.length === 1) {
        return { envelope_id: [folders[0].envelope_id] };
      }
      return {
        envelope_id: [getEnvelopeId(sleeveSmartFoldersData, rootFolderName)],
        folder_names: folders.map(item => item.name)
      };
    }
    return {
      envelope_id: [currentPath.length > 0 ? getEnvelopeId(sleeveSmartFoldersData, rootFolderName) : files[0].envelope_id],
      file_ids: files.map(item => String(item.id))
    };
  };

  const handleItemSelect = (item, e) => {
    e.stopPropagation();
    const itemKey = getItemKey(item);
    let newSelectedItems;
    if (currentPath.length === 0 && item.type === 'folder') {
      if (selectedItems.length === 1 && selectedItems[0].type === 'folder' && getItemKey(selectedItems[0]) !== itemKey) {
        newSelectedItems = [];
      } else {
        newSelectedItems = [item];
      }
    } else if (e.ctrlKey || e.metaKey) {
      newSelectedItems = selectedItems.find(i => getItemKey(i) === itemKey)
        ? selectedItems.filter(i => getItemKey(i) !== itemKey)
        : [...selectedItems, item];
    } else {
      newSelectedItems = [item];
    }
    setSelectedItems(newSelectedItems);
    const clipboardPayload = prepareClipboardData(newSelectedItems);
    if (clipboardPayload) {
      copyToClipboard(clipboardPayload);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!containerRef.current || !containerRef.current.contains(document.activeElement)) return;
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'c') {
        e.preventDefault();
        if (selectedItems.length > 0) {
          const clipboardPayload = prepareClipboardData(selectedItems);
          if (clipboardPayload) {
            copyToClipboard(clipboardPayload);
            toast.success(`Copied ${selectedItems.length} item`, { autoClose: 4000 });
          }
        } else {
          toast.info('No items selected to copy.', { autoClose: 2000 });
        }
      }
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
        e.preventDefault();
        handlePasteClipboardItems();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedItems, clipboardData, currentPath, userId]);

  useEffect(() => {
    const ref = containerRef.current;
    if (!ref) return;
    const handleClick = () => ref.focus();
    ref.addEventListener('click', handleClick);
    return () => ref.removeEventListener('click', handleClick);
  }, []);

  const handleContainerClick = (e) => {
    if (!e.target.closest('.file-card-clickable')) {
      setSelectedItems([]);
    }
  };

  // Debugging input focus and typing
  const handleSearchInputChange = (e) => {
    console.log('Search input changed:', e.target.value); // Debug log
    setSearchText(e.target.value);
  };

  const handleSearchInputClick = (e) => {
    e.stopPropagation(); // Prevent container click from deselecting
    inputRef.current.focus();
    console.log('Search input clicked'); // Debug log
  };

  const handleSearchKeyDown = (e) => {
    console.log('Key pressed:', e.key); // Debug log
    if (e.key === 'Enter') {
      console.log('Enter pressed, search text:', searchText);
    }
  };

  const handleTouchStart = (item, e) => {
    longPressTimer = setTimeout(() => {
      handleItemSelect(item, e);
      setLongPressActiveId(item.id || item.name);
      setLongPressType(item.type);
      setTimeout(() => {
        setLongPressActiveId(null);
        setLongPressType(null);
      }, 1000);
    }, 500);
  };

  const handleTouchEnd = () => {
    clearTimeout(longPressTimer);
  };

  const getRecursiveCounts = (content) => {
    let totalFiles = 0, totalPdfs = 0, totalImages = 0, totalDocx = 0, totalFolders = 0;
    const isFile = (item) => typeof item === 'object' && (item.file_name || item.file_path);
    const isFolder = (item) => typeof item === 'object' && !item.file_name && !item.file_path;

    const traverse = (node) => {
      if (Array.isArray(node)) {
        for (const file of node) {
          totalFiles++;
          const name = file.file_name?.toLowerCase() || '';
          if (name.endsWith('.pdf')) totalPdfs++;
          else if (['.jpg', '.jpeg', '.png', '.webp'].some(ext => name.endsWith(ext))) totalImages++;
          else if (name.endsWith('.docx')) totalDocx++;
        }
      } else if (typeof node === 'object' && node !== null) {
        for (const key in node) {
          if (Array.isArray(node[key])) {
            traverse(node[key]);
          } else if (typeof node[key] === 'object' && node[key] !== null) {
            totalFolders++;
            traverse(node[key]);
          }
        }
      }
    };
    traverse(content);
    return { totalFiles, totalPdfs, totalImages, totalDocx, totalFolders };
  };

  // Memoized recursive counts for all files in current folder and subfolders
  const recursiveCounts = useMemo(() => {
    let content = sleeveSmartFoldersData || {};
    if (currentPath.length === 0) {
      // On root: only count direct folders (sleeves)
      const totalFolders = Array.isArray(currentDisplayItems)
        ? currentDisplayItems.filter(item => item.type === 'folder').length
        : 0;
      return { totalFiles: 0, totalPdfs: 0, totalImages: 0, totalDocx: 0, totalFolders };
    } else {
      for (const folderName of currentPath) {
        content = (content && typeof content === 'object' && content[folderName]) ? content[folderName] : {};
      }
      return getRecursiveCounts(content);
    }
  }, [sleeveSmartFoldersData, currentPath, currentDisplayItems]);

  // Filter options for rc-menu
  const filterOptions = [
    { key: 'all', label: `All Files (${counts.totalFiles + counts.totalFolders})` },
    { key: 'folder', label: `Folders (${counts.totalFolders})` },
    { key: 'pdf', label: `PDFs (${counts.totalPdfs})` },
    { key: 'image', label: `Images (${counts.totalImages})` },
    { key: 'docx', label: `Docx (${counts.totalDocx})` },
    { key: 'other', label: `Others (${counts.totalFiles - (counts.totalPdfs + counts.totalImages + counts.totalDocx)})` },
  ];

  const filterMenu = (
    <Menu
      selectedKeys={[filterType]}
      onClick={({ key }) => {
        setFilterType(key);
        closeDropdown('filter');
      }}
      className="custom-rc-dropdown-menu"
    >
      {filterOptions.map(opt => (
        <MenuItem key={opt.key}>{opt.label}</MenuItem>
      ))}
    </Menu>
  );

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}
      <div className="container-main rounded p-3 bg-white" ref={containerRef} tabIndex={0} style={{ outline: 'none' }} onClick={handleContainerClick}>
        <div className="d-lg-flex justify-content-between align-items-center mb-4">
          <div className="input-group position-relative me-2 mb-2 mb-lg-0 my-files-folder-search-container">
            <input
              ref={inputRef}
              type="text"
              className="form-control py-2 px-3 rounded-2 my-files-folder-search-input"
              placeholder="Type to search..."
              value={searchText}
              onChange={handleSearchInputChange}
              onClick={handleSearchInputClick}
              onKeyDown={handleSearchKeyDown}
              autoFocus le
              style={{ pointerEvents: 'auto', userSelect: 'text' }}
            />
          </div>
          <div className="header-filter-tabs sort-container">
            <div
              className={`sort-item ${sortColumn === "name" ? "active-sort" : "inactive-sort"}`}
              onClick={() => handleSort("name")}
              style={{ width: "90px" }}
            >
              NAME {sortColumn === "name" && (sortDirection === "asc" ? "↑" : "↓")}
            </div>
            <div
              className={`sort-item ${sortColumn === "date" ? "active-sort" : "inactive-sort"}`}
              onClick={() => handleSort("date")}
              style={{ width: "180px" }}
            >
              DATE MODIFIED {sortColumn === "date" && (sortDirection === "asc" ? "↑" : "↓")}
            </div>
          </div>
        </div>

        {/* Filter Dropdown Start */}
        <div className="mb-3" style={{ maxWidth: 220 }}>
          <Dropdown
            trigger={['click']}
            overlay={filterMenu}
            animation="slide-up"
            visible={openDropdowns['filter']}
            onVisibleChange={(visible) => handleDropdownVisibleChange(visible, 'filter')}
          >
            <button className="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center" type="button">
              {filterOptions.find(opt => opt.key === filterType)?.label || 'Filter'}
              <span className="ms-2">&#9662;</span>
            </button>
          </Dropdown>
        </div>
        {/* Filter Dropdown End */}

        {currentPath.length > 0 && (
          <div className="d-flex align-items-center mb-3">
            <button className="btn btn-primary p-0 me-2 d-flex align-items-center" onClick={handleBackClick}>
              <div className="bg-primary px-2 py-1"><IoIosArrowBack className="bi bi-arrow-circle-left" /> Back</div>
            </button>
            {getBreadcrumbs()}
          </div>
        )}

        {filteredAndSortedItems.length === 0 ? (
          <p>No documents found to display in this folder.</p>
        ) : (
          <div className="file-list-item">
            {filteredAndSortedItems.map((item) => {
              const isRootFolder = currentPath.length === 0;
              if (item.type === "folder") {
                const folderKey = `folder-${item.name}`;
                const folderMenu = (
                  <Menu className="custom-rc-dropdown-menu">
                    {!isRootFolder && (
                      <MenuItem key="rename" className="custom-rc-dropdown-item" onClick={e => {
                        e.domEvent.stopPropagation();
                        closeDropdown(folderKey);
                        handleRenameClick(e, item);
                      }}>
                        <i className="bi bi-pencil me-2"></i>Rename
                      </MenuItem>
                    )}
                    {myFilesEnabled && (
                      <MenuItem key="copy" className="custom-rc-dropdown-item" onClick={e => {
                        e.domEvent.stopPropagation();
                        closeDropdown(folderKey);
                        handleSendFolderToMyFiles(item, isRootFolder);
                      }}>
                        <i className="bi bi-folder-plus me-2"></i>Copy to My Files
                      </MenuItem>
                    )}
                  </Menu>
                );
                return (
                  <OverlayTrigger
                    key={item.name}
                    placement="top"
                    overlay={<Tooltip id={`tooltip-folder-${item.name}`}>
                      {longPressActiveId === item.name && longPressType === 'folder'
                        ? 'Long press to select on mobile.'
                        : ' On click, open the file or folder. and Ctrl+Right Click (or Cmd+Right Click), select the file or folder.'}
                    </Tooltip>}
                  >
                    <div
                      className={`file-card file-card-folder folder-border cursor-pointer file-card-clickable${selectedItems.find(i => getItemKey(i) === getItemKey({ ...item, type: 'folder' })) ? ' selected' : ''}`}
                      onClick={() => handleFolderClick(item)}
                      onContextMenu={(e) => {
                        if (e.ctrlKey || e.metaKey) {
                          e.preventDefault();
                          handleItemSelect({ ...item, type: 'folder' }, e);
                        }
                      }}
                      onTouchStart={(e) => handleTouchStart({ ...item, type: 'folder' }, e)}
                      onTouchEnd={handleTouchEnd}
                      style={{ zIndex: activeDropdown === item.name ? 1001 : 1 }}
                    >
                      {item.count > 0 && (
                        <div className="file-count position-absolute top-0 end-0 bg-dark-subtle rounded-circle d-flex justify-content-center align-items-center px-2 py-0 me-2 mt-2" style={{ width: "24px", height: "24px", fontSize: "0.75rem", fontWeight: "bold" }}>
                          {item.count}
                        </div>
                      )}
                      <div className="file-icon-container" style={{ marginTop: "20%" }}>
                        <div className="icon-background">
                          <svg className="plain file-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6H9L11 8H20C20.5523 8 21 8.44772 21 9V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V7C3 6.44772 3.44772 6 4 6Z" fill="#ffcc00" />
                            <path d="M9 6L11 8H20V9H9L7 7H4V6H9Z" fill="#ffd633" />
                          </svg>
                        </div>
                      </div>
                      <div className="file-name d-flex justify-content-start">{highlightSearchText(item.name, searchText)}</div>
                      <div className="dropdown-container">
                        <div className="file-type">FOLDER</div>
                        {(myFilesEnabled || !isRootFolder) && (
                          <Dropdown
                            trigger={['click']}
                            overlay={folderMenu}
                            animation="slide-up"
                            visible={openDropdowns[folderKey]}
                            onVisibleChange={(visible) => handleDropdownVisibleChange(visible, folderKey)}
                          >
                            <span className="three-dots" style={{ cursor: 'pointer' }} onClick={e => e?.stopPropagation?.()}>•••</span>
                          </Dropdown>
                        )}
                      </div>
                    </div>
                  </OverlayTrigger>
                );
              }
              const fileName = item.file_name || "Unnamed File";
              const { icon, class: cardClass, type } = getFileIconAndClass(fileName);
              const isImage = type === 'IMAGE' && item.file_path;
              const fileKey = `file-${item.id || item.file_path}`;
              const fileMenu = (
                <Menu className="custom-rc-dropdown-menu">
                  <MenuItem
                    key="move"
                    className="custom-rc-dropdown-item"
                    onClick={(e) => {
                      e.domEvent.stopPropagation(); // This is the key fix
                      closeDropdown(fileKey);
                      handleFileMoveClick(item);
                    }}
                  >
                    <i className="bi bi-arrows-move me-2"></i>Move
                  </MenuItem>
                  {myFilesEnabled && (
                    <MenuItem
                      key="copy"
                      className="custom-rc-dropdown-item"
                      onClick={(e) => {
                        e.domEvent.stopPropagation();
                        closeDropdown(fileKey);
                        handleSendFileToMyFiles(item);
                      }}
                    >
                      <i className="bi bi-folder-plus me-2"></i>Copy to My Files
                    </MenuItem>
                  )}
                </Menu>
              );
              return (
                <OverlayTrigger
                  key={item.file_path}
                  placement="top"
                  overlay={<Tooltip id={`tooltip-file-${item.file_path}`}>
                    {longPressActiveId === item.file_path && longPressType === 'file'
                      ? 'Long press to select on mobile.'
                      : ' On click, open the file or folder. and Ctrl+Right Click (or Cmd+Right Click), select the file or folder.'}
                  </Tooltip>}
                >
                  <div
                    className={`file-card ${cardClass} cursor-pointer file-card-clickable${selectedItems.find(i => getItemKey(i) === getItemKey({ ...item, type: 'file' })) ? ' selected' : ''}`}
                    onClick={(e) => {
                      if (e.target === e.currentTarget) {
                        handleOpenDocumentModal(item);
                      }
                    }}
                    onContextMenu={(e) => {
                      if (e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        handleItemSelect({ ...item, type: 'file' }, e);
                      }
                    }}
                    onTouchStart={(e) => handleTouchStart({ ...item, type: 'file' }, e)}
                    onTouchEnd={handleTouchEnd}
                  >
                    <div className="file-icon-container">
                      <div className="icon-background">
                        {isImage ? (
                          <img src={item.file_path} alt={fileName} className="plain file-icon" style={{ objectFit: 'cover', borderRadius: 6 }} />
                        ) : (
                          <img src={icon} alt={`${type} Icon`} className="plain file-icon" />
                        )}
                      </div>
                    </div>
                    <div className="file-name">{highlightSearchText(fileName, searchText)}</div>
                    <div className="dropdown-container">
                      <div className="file-type">{type}</div>
                      <Dropdown
                        trigger={['click']}
                        overlay={fileMenu}
                        animation="slide-up"
                        visible={openDropdowns[fileKey]}
                        onVisibleChange={(visible) => handleDropdownVisibleChange(visible, fileKey)}
                      >
                        <span className="three-dots" style={{ cursor: 'pointer' }} onClick={e => e.stopPropagation()}>•••</span>
                      </Dropdown>
                    </div>
                  </div>
                </OverlayTrigger>
              );
            })}
          </div>
        )}
      </div>

      <RenameFolderModal
        show={showRenameModal}
        onHide={() => { setShowRenameModal(false); setSelectedFolder(null); }}
        folderData={selectedFolder}
        onSuccess={handleRenameSuccess}
        onRefreshDocuments={onRefreshDocuments}
      />
      <MoveFilesComponent
        show={showMoveModal}
        onHide={() => setShowMoveModal(false)}
        envelopeId={envelopeId}
        mainFolderName={mainFolderName}
        files={moveFiles}
        onMoveSuccess={handleMoveSuccess}
        onRefreshDocuments={onRefreshDocuments}
      />
      {isSiteFilesModalOpen && (
        <PasteToMyFilesModal
          show={isSiteFilesModalOpen}
          handleClose={() => { setIsSiteFilesModalOpen(false); clearClipboard(); }}
          itemsToPaste={clipboardData ? [clipboardData] : []}
          userId={userId}
          onPasteSuccess={() => { onRefreshDocuments(); clearClipboard(); }}
        />
      )}
    </>
  );
};

export default EnvFilesFolderView;